<template>
  <div
    :id="`advantages-item-${index}`"
    class="advantages__item"
  >
    <div class="row">
      <div class="col-lg-10">
        <h3
          class="advantages__title"
          v-html="item.title"
        ></h3>
        <div class="advantages__description">
          <div
            v-if="isNumbered"
            class="advantages__number"
          >
            {{ index }}
          </div>
          <div
            v-else
            class="advantages__image"
          >
            <img
              v-if="item.image"
              v-lazy-load
              :data-src="item.image"
              alt=""
            >
          </div>
          <div
            class="advantages__content"
            v-html="item.content"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AdvantagesItem',
    props: {
      item: {
        type: Object,
        default() {
          return {}
        }
      },
      index: {
        type: Number,
        default: 0
      },
      isNumbered: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss">
  .advantages__item {
    padding: 24px 0 32px;
    border-top: 1px solid $primaryBorder;

    &:last-child {
      padding-bottom: 0;
    }
  }

  .advantages__title {
    margin-bottom: 24px;
    max-width: 766px;

    @media (max-width: $breakpoint-md) {
      margin-bottom: 16px;
    }
  }

  .advantages__description {
    display: flex;
    flex-direction: row;

    @media (max-width: $breakpoint-lg) {
      flex-wrap: wrap;
    }

    @media (max-width: $breakpoint-md) {
      display: block;
    }
  }

  .advantages__number {
    width: 40%;
    color: $secondary;
    font-size: 87px;
    line-height: 1;

    @media (max-width: $breakpoint-lg) {
      font-size: 64px;
    }

    @media (max-width: $breakpoint-sm) {
      font-size: 48px;
    }
  }

  .advantages__image {
    width: 40%;

    @media (max-width: $breakpoint-lg) {
      width: 100%;
      margin-bottom: 16px;
    }

    img {
      max-width: 240px;
      max-height: 72px;

      @media (max-width: $breakpoint-lg) {
        max-height: 64px;
      }

      @media (max-width: $breakpoint-sm) {
        max-height: 48px;
      }
    }
  }

  .advantages__content {
    width: 60%;

    @media (max-width: $breakpoint-lg) {
      width: 100%;
      padding-left: calc(#{$grid-column} * 2);
    }

    p, ol, ul {
      margin-bottom: 1em;
    }

    *:last-child {
      margin-bottom: 0;
    }

    em {
      font-style: normal;
    }
  }
</style>